//
// サービス申し込み画面
//

// NOTE: DOMContentLoadedではブラウザバック時に反応できないためpageshowを使用
window.addEventListener('pageshow', (element) => {
  const pages = document.querySelectorAll('.entry-card-page')
  if (pages.length == 0) return;

  // FIXME: 日時会場がないサービスでの余白調整。DOM構成の変更とcssで解決したい。
  const serviceName = document.getElementById('service-name')
  const serviceDetails = document.getElementsByClassName('service-details')[0]

  const agreementCheckboxes = [].slice.call(document.getElementsByClassName('hidden-checkbox'))
  const submitButtons = [].slice.call(document.getElementsByClassName('btn'))

  // FIXME: 日時会場がないサービスでの余白調整。DOM構成の変更とcssで解決したい。
  if (serviceDetails.offsetHeight == 0 ) {
    serviceName.style.marginBottom = 0
  }

  if (agreementCheckboxes.length > 0) {
    const checked = agreementCheckboxes[0].checked
    toggleDisabledToAllButtons(!checked)
    reflectCheckedToAllCheckboxes(checked)

    agreementCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (element) => {
        const checked = element.target.checked
        toggleDisabledToAllButtons(!checked)
        reflectCheckedToAllCheckboxes(checked)
      })
    })
  }

  function toggleDisabledToAllButtons(disabled) {
    submitButtons.forEach((button) => {
      button.disabled = disabled
      if (disabled) {
        button.classList.add('is-disable')
      } else {
        button.classList.remove('is-disable')
      }
    })
  }

  function reflectCheckedToAllCheckboxes(checked) {
    agreementCheckboxes.forEach((checkbox) => checkbox.checked = checked)
  }
})
